
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'UIFilterCheckbox',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'base'
    }
  },
  methods: {
    handleChange(event: Event) {
      this.$emit('change', (event.target as HTMLInputElement).checked)
    }
  },
  computed: {
    checkBoxSize(): string {
      const sizes: Record<string, string> = {
        small: 'h-3 w-3',
        base: 'h-4 w-4 font-medium',
        large: 'h-5 w-5 font-semibold'
      }
      return sizes[this.size] ?? 'h-5 w-5'
    }
  }
})
